import React, { useState } from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus, faCheck, faMinus } from '@fortawesome/free-solid-svg-icons';
import classNames from "classnames";
import { services } from "../../_helpers/other-data";

export const FaqSection = () => {
    const [answer, setanswer] = useState();
    return (
        <div 
            className='section-unit'
        >
            <img src='./images/faq_img.png' className='section-image' alt='' />
            <div className='section-text'>
                {/* first box */}
                <div className='faq-box'>
                    <div 
                        className='faq-unit' 
                        onClick={() => {
                            answer === 'q1'? setanswer() :setanswer('q1');
                        }}
                    >
                        <div className={classNames('rw-al-cnt','faq-unit-lbl')}>
                            <span className='faq-question'>What services do you offer?</span>
                            <div className="pr-btn">
                                <div className={classNames('anim-button',{'anim-rot': answer === 'q1'})}>
                                    <FontAwesomeIcon icon={ answer === 'q1' ? faMinus : faPlus} />
                                </div>
                            </div>
                        </div>
                        
                        <div className={classNames('faq-answers',{'unwrap': answer === 'q1' })}>
                            <p className='faq-p'>
                                We offer comprehensive immigration and visa consulting services,
                                including visa application assistance, document preparation.
                            </p>
                            {   services.map((service,k) => (
                                    <div className='pt-unit' key={k}>
                                        <FontAwesomeIcon icon={faCheck} color='#888' className='hs-4' />
                                        <span className='pt-unit-text'>
                                           {service}
                                        </span>
                                    </div>
                                ))
                           }
                        </div>
                    </div>
                </div>

                {/* second box */}
                <div className='faq-box'>
                    <div 
                        className='faq-unit' 
                        onClick={() => {
                            answer === 'q2'? setanswer() :setanswer('q2');
                        }}
                    >
                        <div className={classNames('rw-al-cnt','faq-unit-lbl')}>
                            <div className='faq-question'>What is the consultation process like?</div>
                            <div className="pr-btn">
                                <div className={classNames('anim-button',{'anim-rot': answer === 'q2'})}>
                                    <FontAwesomeIcon icon={ answer === 'q2' ? faMinus : faPlus} />
                                </div>
                            </div>
                        </div>
                        
                        <div className={classNames('faq-answers',{'unwrap': answer === 'q2' })}>
                            <p className='faq-p'>
                                We offer comprehensive immigration and visa consulting services,
                                including visa application assistance, document preparation
                            </p>
                            <div className='pt-unit'>
                                <FontAwesomeIcon icon={faCheck} color='#888' className='hs-4' />
                                <span className='pt-unit'>Comprehensive Visa Assistance</span>
                            </div>
                            <div className='pt-unit'>
                                <FontAwesomeIcon icon={faCheck} color='#888' className='hs-4' />
                                <span className='pt-unit'>Visa Category Expertise</span>
                            </div>
                            <div className='pt-unit'>
                                <FontAwesomeIcon icon={faCheck} color='#888' className='hs-4' />
                                <span className='pt-unit'>Transparency and Communication</span>
                            </div>
                        </div>
                    </div>
                </div>
                {/* third box */}
                <div className='faq-box'>
                    <div 
                        className='faq-unit' 
                        onClick={() => {
                            answer === 'q3'? setanswer() :setanswer('q3');
                        }}
                    >
                        <div className={classNames('rw-al-cnt','faq-unit-lbl')}>
                            <div className='faq-question'>How much do your services normally cost?</div>
                            <div className="pr-btn">
                                <div className={classNames('anim-button',{'anim-rot': answer === 'q3'})}>
                                    <FontAwesomeIcon icon={ answer === 'q3' ? faMinus : faPlus} />
                                </div>
                            </div>
                        </div>
                        
                        <div className={classNames('faq-answers',{'unwrap': answer === 'q3' })}>
                            <p className='faq-p'>
                                We offer comprehensive immigration and visa consulting services,
                                including visa application assistance, document preparation
                            </p>
                            <div className='pt-unit'>
                                <FontAwesomeIcon icon={faCheck} color='#888' className='hs-4' />
                                <span className='pt-unit'>Comprehensive Visa Assistance</span>
                            </div>
                            <div className='pt-unit'>
                                <FontAwesomeIcon icon={faCheck} color='#888' className='hs-4' />
                                <span className='pt-unit'>Visa Category Expertise</span>
                            </div>
                            <div className='pt-unit'>
                                <FontAwesomeIcon icon={faCheck} color='#888' className='hs-4' />
                                <span className='pt-unit'>Transparency and Communication</span>
                            </div>
                        </div>
                    </div>
                </div>
                {/* fourth box */}
                <div className='faq-box'>
                    <div 
                        className='faq-unit' 
                        onClick={() => {
                            answer === 'q4'? setanswer() :setanswer('q4');
                        }}
                    >
                        <div className={classNames('rw-al-cnt','faq-unit-lbl')}>
                            <div className='faq-question'>How do I get started with your services?</div>
                            <div className="pr-btn">
                                <div className={classNames('anim-button',{'anim-rot': answer === 'q4'})}>
                                    <FontAwesomeIcon icon={ answer === 'q4' ? faMinus : faPlus} />
                                </div>
                            </div>
                        </div>
                        
                        <div className={classNames('faq-answers',{'unwrap': answer === 'q4' })}>
                            <p className='faq-p'>
                                We offer comprehensive immigration and visa consulting services,
                                including visa application assistance, document preparation
                            </p>
                            <div className='pt-unit'>
                                <FontAwesomeIcon icon={faCheck} color='#888' className='hs-4' />
                                <span className='pt-unit'>Comprehensive Visa Assistance</span>
                            </div>
                            <div className='pt-unit'>
                                <FontAwesomeIcon icon={faCheck} color='#888' className='hs-4' />
                                <span className='pt-unit'>Visa Category Expertise</span>
                            </div>
                            <div className='pt-unit'>
                                <FontAwesomeIcon icon={faCheck} color='#888' className='hs-4' />
                                <span className='pt-unit'>Transparency and Communication</span>
                            </div>
                        </div>
                    </div>
                </div>
                {/* fifth box */}
                <div className='faq-box'>
                    <div 
                        className='faq-unit' 
                        onClick={() => {
                            answer === 'q5'? setanswer() :setanswer('q5');
                        }}
                    >
                        <div className={classNames('faq-unit-lbl')}>
                            <div className='faq-question'>What is your success rate with visa applications?</div>
                            <div className="pr-btn">
                                <div className={classNames('anim-button',{'anim-rot': answer === 'q5'})}>
                                    <FontAwesomeIcon icon={ answer === 'q5' ? faMinus : faPlus} />
                                </div>
                            </div>
                        </div>
                        
                        <div className={classNames('faq-answers',{'unwrap': answer === 'q5' })}>
                            <p className='faq-p'>
                                We offer comprehensive immigration and visa consulting services,
                                including visa application assistance, document preparation
                            </p>
                            <div className='pt-unit'>
                                <FontAwesomeIcon icon={faCheck} color='#888' className='hs-4' />
                                <span className='pt-unit'>Comprehensive Visa Assistance</span>
                            </div>
                            <div className='pt-unit'>
                                <FontAwesomeIcon icon={faCheck} color='#888' className='hs-4' />
                                <span className='pt-unit'>Visa Category Expertise</span>
                            </div>
                            <div className='pt-unit'>
                                <FontAwesomeIcon icon={faCheck} color='#888' className='hs-4' />
                                <span className='pt-unit'>Transparency and Communication</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}